export const getSlug = (content, slugPrefix) => {
  if (!content) {
    return `/${slugPrefix}`
  }

  const TypeName = '__typename'

  const typeN = content[TypeName] ? content[TypeName].toUpperCase() : null

  let slug = ''

  const integrationType =
    typeN === 'IntegrationModelRecord'.toUpperCase() ||
    typeN === 'IntegrationCategoryModelRecord'.toUpperCase()

  if (integrationType) {
    slug = `/${slugPrefix}/integrations/${content?.slug}`
  } else if (
    typeN === 'CustomerModelRecord'.toUpperCase() ||
    typeN === 'CustomerModelRecord'.toUpperCase()
  ) {
    slug = `/${slugPrefix}/customers/${content?.slug}`
  } else if (
    typeN === 'ArticleModelRecord'.toUpperCase() ||
    typeN === 'ArticleModelRecord'.toUpperCase()
  ) {
    const categories = content?.categoriesCollection?.items || content?.categories || []
    if (categories?.length && content?.slug) {
      slug = `/${slugPrefix}/blog/${categories?.[0]?.slug}/${content?.slug}`
    }
  } else if (
    typeN === 'CareersPageModelRecord'.toUpperCase() ||
    typeN === 'CareersPageModelRecord'.toUpperCase()
  ) {
    slug = `/en/careers/${content?.slug || ''}`
  } else if (typeN === 'NavigationItemModelRecord'.toUpperCase()) {
    if (content['externalUrl']) slug = content['externalUrl']
    if (content['relativePath'])
      slug = `/${slugPrefix}${content['relativePath']}`.replace(/\/\//g, '/')
  } else {
    slug = `/${slugPrefix}/${content?.slug || ''}`
  }

  return slug.replace(/\/{2,3}/g, '/')
}

export const buildLangSlug = (slug, slugPrefix) => {
  return `/${slugPrefix}/${slug}`.replace(/\/\//g, '/')
}
